import React from 'react';
import { styled } from '@mui/material';
import { Label } from './Label';

interface FieldGroupProps {
    label: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
    required?: boolean;
}

export function FieldGroup({ label, children, style, required }: FieldGroupProps) {
    return (
        <Group style={style}>
            <Label>
                {label}
                {required && ' *'}
            </Label>
            {children}
        </Group>
    );
}

const Group = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
});
